module.exports = __webpack_public_path__ + "static/img/tab-banner1.99627e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/8/tab-banner1.png
// module id = +3Xz
// module chunks = 1